export const blockIconsHomeHomeStorageNew = (
	<span className='material-symbols-outlined'>home_storage</span>
);
